module.exports = __webpack_public_path__ + "media/img/logo-5ed71b0dc6539f1fd059d0bbf3a24f60.svg";